import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Image,
  Input,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  useToast
} from "@chakra-ui/react";
import { partial } from "filesize";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { BsCheckCircleFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import notepad from "../../../../img/notepad.svg";
import { ITopic } from "../../../../models/admin/course-creation.model";
import AdminHelpers from "../../../../services/admin/admin.service";

const AdminCurriculum = ({
  nextPage,
  prePage,
  ...rest
}: {
  nextPage: any;
  prePage: any;
}) => {
  const navigate = useNavigate();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [content_types, setContentTypes] = useState<any[]>();
  const [audio, setAudio] = useState(false);
  const [video, setVideo] = useState(false);
  const [article, setArticle] = useState(false);
  const [show_lesson, setShowLesson] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [topicsubmit, setSubmitTopic] = useState(false);
  const [filetype, setFiletype] = useState<string | undefined>("");
  const [batchFile, setbatchFile] = useState<File | undefined>();
  const [uploadFileSize, setUploadFileSize] = useState("");
  const [filename, setFilename] = useState("");
  const [topic, setTopic] = useState("");
  const [newcourseId, setNewcourseId] = useState("");
  const [lecture_list, setLecturelist] = useState<ITopic[]>();

  const [show_input, setShowInput] = useState(true);

  const toast = useToast();

  useEffect(() => {
    const new_course_id = localStorage.getItem("new-course-id");
    if (new_course_id) setNewcourseId(new_course_id);

    const contentTypes = [
      {
        id: "article",
        title: "Article",
      },
      {
        id: "video",
        title: "Video",
      },
      {
        id: "audio",
        title: "Audio",
      },
    ];
    setContentTypes(contentTypes);
  }, []);

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      return errors;
    },
    initialValues: {
      lessonTitle: "",
      audio_file: "",
      video_file: "",
      article_file: "",
    },
    onSubmit: async (values) => {
      console.log(values);
    },
  });

  const createLecture = async () => {
    setSubmitTopic(true);

    const lecturedata = {
      title: topic,
      description: "",
    };
    const basicResponse = await AdminHelpers.createCourseTopic(
      lecturedata,
      newcourseId
    );
    if (basicResponse) {
      const lecture_data = basicResponse.data;
      if (lecture_list) {
        setLecturelist([...lecture_list, lecture_data]);
      } else {
        setLecturelist([lecture_data]);
      }
      setShowInput(false);

      setTopic("");
      toast({
        title: "Course Lecture",
        description: "Course Lecture added",
        status: "success",
      });
    }
  };
  const addLesson = async (lectureIndex: number) => {
    setSubmitting(true);
    if (lecture_list) {
      const currentLecture = lecture_list.at(lectureIndex) as ITopic;

      try {

          const formData = new FormData();
          formData.append("title", formik.values.lessonTitle);
          formData.append("course_topic_id", currentLecture.uuid);
          formData.append("description", "");
          formData.append("duration", "");
          // formData.append("content_type", "file");


          const lessonupload = await AdminHelpers.createCourseLessons(
            formData,
            newcourseId
          );
          if (lessonupload) {
            if (currentLecture.lesson) {
              currentLecture.lesson.push(lessonupload.data);
            } else {
              currentLecture.lesson = [lessonupload.data];
            }
            lecture_list.splice(lectureIndex, 1, { ...currentLecture });

            formik.resetForm();
            setShowLesson(false);
            setbatchFile(undefined);
            setFilename("");
            setFiletype("");
            setUploadFileSize("");

            toast({
              title: "Course Lesson",
              description: "Course lesson added successfully",
              status: "success",
            });
          }
        
      } catch (error: any) {
        toast({
          title: "Course Lesson",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    }
  };

  const showContentType = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (e.target.value == "audio") {
      setAudio(true);
      setVideo(false);
      setArticle(false);
      setFilename("");
      setbatchFile(undefined);
    }
    if (e.target.value == "video") {
      setAudio(false);
      setVideo(true);
      setArticle(false);
      setFilename("");
      setbatchFile(undefined);
    }
    if (e.target.value == "article") {
      setAudio(false);
      setVideo(false);
      setArticle(true);
      setFilename("");
      setbatchFile(undefined);
    }
  };
  const completeCourseCreation = () => {
    toast({
      title: "New Course ",
      description: "Course completed successfully",
      status: "success",
    });
    localStorage.removeItem("new-course-id");
    localStorage.removeItem("naptin_course_info");
    localStorage.removeItem("naptin_course_page_no");
    navigate(-1);
  };
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value) {
      const fileName = e.target.files?.item(0)?.name as string;

      const fileType = e.target.files?.item(0)?.type;

      const file = e.target.files?.item(0) as File;

      if (fileType?.split("/").at(0) !== "audio" && audio) {
        formik.setErrors({ audio_file: "Only Audio file format is supported" });
        return;
      } else if (fileType?.split("/").at(0) !== "video" && video) {
        formik.setErrors({ video_file: "Only Video file format is supported" });
        return;
      } else if (fileType?.split("/").at(1) !== "pdf" && article) {
        formik.setErrors({ article_file: "Only PDF file format is supported" });
        return;
      } else {
        setFilename(fileName);
        setFiletype(fileType);
        setbatchFile(file);
        const fileSize = partial({ base: 2, standard: "jedec" });
        setUploadFileSize(fileSize(file.size));
      }
    } else {
      setFilename("");
      setbatchFile(undefined);
    }

    formik.handleChange(e);
  };

  return (
    <Box px={8} mb="50px">
      <Flex justifyContent="center" mb="35px">
        <Text mx="auto" fontSize="32px" fontWeight="800">
          Curriculum
        </Text>
      </Flex>

      <Box width="95%" mx="auto">
        <Text color="#353535" fontSize="20px" pb="20px" fontWeight="600">
          Course Content
        </Text>
      </Box>
      <Box width="95%" mx="auto">
        {lecture_list &&
          lecture_list.length > 0 &&
          lecture_list.map((each, index) => (
            <Box key={index} bg="#FDFDFD" pb="10px" mb="15px" pt="10px" pl="1rem">
              <Text
                ml="2.5%"
                color="#616161"
                fontSize="16px"
                fontWeight="500"
                pb="20px"
              >
                Lecture {`${index + 1} : ${each.title}`}
              </Text>
              {each.lesson &&
                each.lesson.length > 0 &&
                each.lesson.map((eachlesson, lessonindex) => (
                  <Flex justifyContent="space-between" w="100%" marginBottom={"8px"} >
                    <HStack>
                      <Image src={notepad} />
                      <Box flex="1" textAlign="left">
                        {lessonindex + 1} : {eachlesson.title}
                      </Box>
                    </HStack>
                  </Flex>
                ))}
              {show_lesson && lecture_list.length - 1 === index && (
                <Box ml="3.5%" pr="15px">
                  <FormControl>
                    <FormLabel fontWeight="700" color="#353535" fontSize={13}>
                      Lesson title
                    </FormLabel>
                    <Flex>
                      <Input
                        bg="inputText.500"
                        placeholder="Enter title"
                        value={formik.values.lessonTitle}
                        name="lessonTitle"
                        onChange={formik.handleChange}
                        fontSize={12}
                      />
                    </Flex>
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.lessonTitle}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl mb="25px" hidden>
                    <Flex justifyContent="space-between">
                      <FormLabel
                        mt="10px"
                        fontWeight="700"
                        color="#353535"
                        width="200px"
                        fontSize={13}
                      >
                        Content Type
                      </FormLabel>
                      <Select
                        variant="outline"
                        width="300px"
                        mt="5px"
                        bg="inputText.500"
                        size="sm"
                        placeholder="Select content type"
                        name="contentType"
                        onChange={(e) => {
                          showContentType(e);
                        }}
                        fontSize={12}
                        color="brand.subtitle"
                      >
                        {content_types?.map((each) => (
                          <option key={each.id} value={each.id}>
                            {" "}
                            {each.title}{" "}
                          </option>
                        ))}
                      </Select>
                    </Flex>
                  </FormControl>

                  <Box hidden>
                    {filename ? (
                      <Box>
                        <Table variant="unstyled">
                          <Thead fontWeight="semibold">
                            <Tr color="brand.subtitle" fontSize={14}>
                              <Td>Filename</Td>
                              <Td>Type</Td>
                              <Td>Size</Td>
                            </Tr>
                          </Thead>

                          <Tbody>
                            <Tr fontSize={13} color="brand.subtitle">
                              <Td maxW="20em">{filename}</Td>
                              <Td>{filetype}</Td>
                              <Td>{uploadFileSize}</Td>
                            </Tr>
                          </Tbody>
                        </Table>
                      </Box>
                    ) : audio ? (
                      <FormControl mr={10}>
                        <FormLabel
                          fontWeight="600"
                          color="#616161"
                          fontSize={13}
                        >
                          Upload Audio
                        </FormLabel>
                        <Text fontWeight="400" color="#959595" fontSize="14px">
                          Upload an audio resource to the course.
                        </Text>

                        <input
                          accept="audio/*"
                          type="file"
                          name="audio_file"
                          ref={inputRef}
                          onChange={(e) => handleFileChange(e)}
                          style={{ display: "none" }}
                        ></input>
                        <Input
                          cursor="pointer"
                          placeholder="No file selected"
                          defaultValue={filename}
                          mt="10px"
                          borderColor="#eeeeee"
                          fontSize={14}
                          bg="#fafafa"
                          onClick={() => inputRef?.current?.click()}
                          border="2px dashed"
                          borderRadius={2}
                        />
                        <FormErrorMessage fontSize={12}>
                          {" "}
                          {formik.errors.audio_file}{" "}
                        </FormErrorMessage>
                      </FormControl>
                    ) : video ? (
                      <FormControl mr={10}>
                        <FormLabel
                          fontWeight="600"
                          color="#616161"
                          fontSize={13}
                        >
                          Upload Video
                        </FormLabel>
                        <Text fontWeight="400" color="#959595" fontSize="14px">
                          Upload a video resource to the course. (Not larger
                          than 2MB)
                        </Text>

                        <input
                          accept="video/*"
                          type="file"
                          name="video_file"
                          ref={inputRef}
                          onChange={(e) => handleFileChange(e)}
                          style={{ display: "none" }}
                        ></input>
                        <Input
                          cursor="pointer"
                          placeholder="No file selected"
                          defaultValue={filename}
                          mt="10px"
                          borderColor="#eeeeee"
                          fontSize={14}
                          bg="#fafafa"
                          onClick={() => inputRef?.current?.click()}
                          border="2px dashed"
                          borderRadius={2}
                        />

                        <FormErrorMessage fontSize={12}>
                          {" "}
                          {formik.errors.video_file}{" "}
                        </FormErrorMessage>
                      </FormControl>
                    ) : article ? (
                      <FormControl mr={10}>
                        <FormLabel
                          fontWeight="600"
                          color="#616161"
                          fontSize={13}
                        >
                          Upload Article
                        </FormLabel>
                        <Text fontWeight="400" color="#959595" fontSize="14px">
                          Upload an article resource to the course. (Not larger
                          than 2MB)
                        </Text>

                        <input
                          accept="application/pdf"
                          type="file"
                          name="article_file"
                          ref={inputRef}
                          onChange={(e) => handleFileChange(e)}
                          style={{ display: "none" }}
                        ></input>
                        <Input
                          cursor="pointer"
                          placeholder="No file selected"
                          defaultValue={filename}
                          mt="10px"
                          borderColor="#eeeeee"
                          fontSize={14}
                          bg="#fafafa"
                          onClick={() => inputRef?.current?.click()}
                          border="2px dashed"
                          borderRadius={2}
                        />

                        <FormErrorMessage fontSize={12}>
                          {" "}
                          {formik.errors.article_file}{" "}
                        </FormErrorMessage>
                      </FormControl>
                    ) : (
                      <Box></Box>
                    )}
                  </Box>
                  {
                    <Flex justifyContent={"center"} pt="10px">
                      <Button
                        py="13px"
                        px="30px"
                        onClick={() => addLesson(index)}
                        fontSize={11}
                        borderRadius={0}
                        colorScheme="red"
                        size="sm"
                      >
                        Add lesson
                      </Button>
                    </Flex>
                  }
                </Box>
              )}
              {!show_lesson && lecture_list.length - 1 === index && (
                <Flex justifyContent={"flex-end"}>
                  <Button
                    py="13px"
                    px="30px"
                    mt="30px"
                    fontSize={11}
                    onClick={() => setShowLesson(true)}
                    borderRadius={0}
                    colorScheme="red"
                    size="sm"
                  >
                    Add lesson
                  </Button>
                </Flex>
              )}
            </Box>
          ))}
      </Box>
      {!show_input && (
        <Button
          colorScheme="white"
          color="red"
          onClick={() => setShowInput(true)}
          size="sm"
          fontSize={11}
          borderRadius={10}
          px={10}
        >
          ADD LECTURE
        </Button>
      )}
      {show_input && (
        <Box width="95%" mx="auto">
          <form>
            <Box bg="#FDFDFD" pb="30px" mb="25px" pt="20px" px="20px">
              <FormControl>
                <FormLabel fontWeight="700" color="#353535" fontSize={13}>
                  Lecture: {lecture_list && lecture_list?.length + 1}
                </FormLabel>
                <Flex>
                  <Input
                    bg="inputText.500"
                    placeholder="Enter title"
                    value={topic}
                    name="topic"
                    onChange={(e) => {
                      setTopic(e.target.value);
                    }}
                    fontSize={12}
                  />
                  <Center
                    ml="20px"
                    cursor={"pointer"}
                    onClick={() => createLecture()}
                  >
                    <BsCheckCircleFill fontSize="28px" color={"#EC3337"} />
                  </Center>
                </Flex>
              </FormControl>
            </Box>
          </form>
        </Box>
      )}

      <Flex mb="100px" justifyContent="space-between" mt={2}>
        <Button
          colorScheme="white"
          color="red"
          onClick={prePage}
          size="sm"
          fontSize={11}
          borderRadius={10}
          px={10}
        >
          PREVIOUS
        </Button>

        <HStack>
          <Button
            py="13px"
            px="30px"
            onClick={() => completeCourseCreation()}
            fontSize={11}
            borderRadius={0}
            colorScheme="red"
            size="sm"
          >
            COMPLETE
          </Button>
        </HStack>
      </Flex>
    </Box>
  );
};

export default AdminCurriculum;
